import { useEffect, useState, useCallback, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";

import { useGlobalSpinnerActionsContext } from "./../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";

import equipmentConstants from "./../../../Constants/EquipmentConstants";
import equipmentActions from "./../../../Actions/EquipmentActions";
import equipmentStore from "./../../../Stores/EquipmentStore";

import tabsConstants from "./../../../Constants/TabsConstants";
import tabsActions from "./../../../Actions/TabsActions";
import tabsStore from "./../../../Stores/TabsStore";

import DatepickerEntry from "./../../helpers/DatepickerEntry";
import CheckboxEntry from "./../../helpers/CheckBoxEntry";
import commonUtils from "../../../helpers/commonUtils";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import SelectEntry2 from "../../helpers/SelectEntry2";
import TabsActions from "./../../../Actions/TabsActions";
const Allgemein = ({ anlageid, handleTourGuid, setIsEdit }) => {
  //--context
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [renderMe, setRenderMe] = useState(null);
  const [data, setData] = useState(null);
  const isMountedRef = useRef(null);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  let equipmentImageListInitState = {
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  };
  let equipmentFileListInitState = {
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  };
  const [equipmentImagesData, setEquipmentImagesData] = useState(
    equipmentImageListInitState,
  );
  const [equipmentFilesData, setEquipmentFilesData] = useState(
    equipmentFileListInitState,
  );
  const ImageFileInputRef = useRef(null);
  const FileInputRef = useRef(null);

  const _className = (item) => {
    if (item) {
      return "form-control bgMandtory";
    } else {
      return "form-control";
    }
  };

  let location = useLocation();
  let params = useParams();

  // fetch data start ---
  const fetchData = useCallback(() => {
    setGlobalSpinner(true);
    var _anlageid = sessionStorage.getItem("eqId") || anlageid;
    if (_anlageid !== null && _anlageid !== undefined) {
      tabsActions.getEquiDetails(_anlageid);
    }
  }, [anlageid]);
  // fetch data end ----------

  useEffect(() => {
    isMountedRef.current = true;

    fetchData();

    return () => (isMountedRef.current = false);
  }, [fetchData]);

  useEffect(() => {
    function updateData() {
      let _item = [];
      setData(null);
      var _details = tabsStore.getResult();
      if (isMountedRef.current) {
        const _dataRow = _details.details;
        _dataRow.map((item, index) => {
          item.tracker = index + 1;
          _item.push(item);
        });
        _details["details"] = _item;
        setData(_details);
        handleTourGuid(1);
      }
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_EQUIPMENTDETAIL_SUCCESS,
      updateData,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_EQUIPMENTDETAIL_SUCCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      var res = tabsStore.getResult();
      toast.error(res);
      setData(null);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_EQUIPMENTDETAIL_FAILURE,
      updateData,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_EQUIPMENTDETAIL_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateSuccess() {
      var res = equipmentStore.getResult();
      if (res) {
        toast.success(localization.equipmentUpdateSuccess);
        setEquipmentImagesData(equipmentImageListInitState);
        setEquipmentFilesData(equipmentFileListInitState);
      }
      setGlobalSpinner(false);
      TabsActions.getEquipmentOverviewDetails(anlageid);
      setIsEdit(false);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.UPDATE_EQUIPMENT_SUCCESS,
      updateSuccess,
    );
    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.UPDATE_EQUIPMENT_SUCCESS,
        updateSuccess,
      );
    };
  }, []);

  useEffect(() => {
    function updatefailure() {
      var res = equipmentStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.UPDATE_EQUIPMENT_FAILURE,
      updatefailure,
    );
    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.UPDATE_EQUIPMENT_FAILURE,
        updatefailure,
      );
    };
  }, []);

  const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };

  useEffect(() => {
    let tmp = null;

    if (data !== null && data !== undefined) {
      const rows = chunkArray(data.details, 2);
      if (rows === null || rows === undefined) {
        tmp = null;
      } else {
        tmp = rows.map((row, rowIndex) => {
          return (
            <div className="row" key={rowIndex}>
              {row.map((item, index) => {
                if (item.isDropdown) {
                  if (item.typ.toLowerCase().includes("datetime")) {
                    return (
                      <div className="col-6" key={item.tracker}>
                        <DatepickerEntry
                          item={item}
                          OnDateChange={handelOnchangeDate}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div className="col-6" key={item.tracker}>
                        <SelectEntry2
                          item={item}
                          OnSelectChange={handelOnChangeSelect}
                          isAddEquipment={false}
                        />
                      </div>
                    );
                  }
                } else {
                  if (item.typ.toLowerCase().includes("bool")) {
                    return (
                      <div className="col-6" key={item.tracker}>
                        <CheckboxEntry
                          item={item}
                          handleCheckboxChange={handleCheckboxChange}
                          formType="edit"
                        />
                      </div>
                    );
                  } else {
                    let _type =
                      item.typ.toLowerCase().includes("int") ||
                      item.typ.toLowerCase().includes("float")
                        ? "number"
                        : "text";
                    var _input = item.editbarFeld ? (
                      <input
                        type={_type}
                        className={_className(item.mandatoryField)}
                        defaultValue={item.value || ""}
                        onChange={(e) => {
                          e.preventDefault();
                          handelOnInputchange(e.target.value, item.tracker);
                        }}
                        name={item.bezeichnung}
                        id={item.standardAttributId}
                        key={item.standardAttributId}
                        step="any"
                        placeholder={item.bezeichnung.trim()}
                      />
                    ) : (
                      <input
                        type={_type}
                        className={_className(item.mandatoryField)}
                        defaultValue={item.value || ""}
                        name={item.bezeichnung}
                        id={item.standardAttributId}
                        key={item.standardAttributId}
                        placeholder={item.bezeichnung.trim()}
                        readOnly
                        step="any"
                      />
                    );
                    return (
                      <div className="form-group col-6" key={item.tracker}>
                        <label className="">
                          {item.bezeichnung}
                          {item.mandatoryField ? (
                            <>
                              <span className="requiredCls"></span>
                            </>
                          ) : (
                            <></>
                          )}
                        </label>
                        {_input}
                      </div>
                    );
                  }
                }
              })}
            </div>
          );
        });
      }
    }
    setRenderMe(tmp);
    return () => {};
  }, [data]);

  const handelOnChangeSelect = (value, item) => {
    ObjectUpdate(value, item);
  };

  const handleCheckboxChange = (value, item, stdId) => {
    if (stdId === "RiskAnalysis" && value === true) {
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(localization.riskAnaMsg);
      setCallbackData({
        value,
        item,
        stdId,
      });
      setEventType("RISK_CONFIRMATION");
    } else {
      ObjectUpdate(value.toString(), item);
    }
  };

  const handelOnInputchange = (value, item) => {
    ObjectUpdate(value, item);
  };

  const handelOnchangeDate = (date, item) => {
    ObjectUpdate(date, item);
  };

  const ObjectUpdate = (newValue, index) => {
    let _copyDetails = [...data.details];
    _copyDetails[index - 1]["value"] = newValue;

    data.details = _copyDetails;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    var planeText = "";
    var Isvalue = false;
    var dataDetails = data.details;
    var item = [];
    dataDetails.map((item, index) => {
      if (item.value) {
        item["value"] = item["value"].trim();
      }
    });
    // setData(_tempdata);
    for (let i = 0; i <= dataDetails.length - 1; i++) {
      Isvalue =
        dataDetails[i].value === null ||
        dataDetails[i].value.toString() === "" ||
        dataDetails[i].value.toString() === undefined
          ? true
          : false;
      if (dataDetails[i].mandatoryField && Isvalue) {
        planeText = localization.MandatoryMissing;
        item.push(dataDetails[i].bezeichnung);
      }
    }
    if (planeText.length > 0) {
      const Msg = () => {
        return (
          <>
            {planeText}
            <br />
            {item.map((key, index) => {
              return (
                <>
                  <br />
                  {key}
                </>
              );
            })}
          </>
        );
      };
      toast.error(<Msg />);
    } else {
      const _itemData = dataDetails.map(({ tracker, ...rest }) => {
        return rest;
      });
      data.details = _itemData;
      data.documents = {
        AnlageId: anlageid,
        Files: equipmentFilesData.filetoStringarray,
      };
      data.EquipmentPhotos = equipmentImagesData.filetoStringarray;
      setGlobalSpinner(true);
      data.userid = sessionStorage.getItem("userid");
      equipmentActions.UpdateEquipment(data);
    }
  };

  let disabled =
    sessionStorage.getItem("isReaderOnly") === "true" ? "true" : "";

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "RISK_CONFIRMATION":
          ObjectUpdate(data.value.toString(), data.item);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const handleDrop = (event, type) => {
    event.preventDefault();
    event.stopPropagation(); //make sure the event is not propagated from child to parent

    var files = [...event.dataTransfer.files]; // convert the values to a js array
    var fileName = "";
    var fileExtension = "";
    if (files && files.length > 0) {
      files.map((file) => {
        if (type === "Images" && !file.type.startsWith("image/")) {
          toast.error(localization.onlyImagesAllowed);
          return false;
        }

        if (type === "Files") {
          fileName = file.name;
          fileExtension = fileName.split(".").pop().toLowerCase();
          if (fileExtension === "exe" || fileExtension === "bat") {
            toast.error(localization.executableFilesNotAllowed);
            return false;
          }
        }
      });
      const existingFiles =
        type == "Images"
          ? equipmentImagesData.fileList.map((f) => f.name)
          : equipmentFilesData.fileList.map((f) => f.name);
      files = files.filter((f) => !existingFiles.includes(f.name));

      files.forEach((element) => {
        let reader = new FileReader();
        reader.onload = () => {
          if (type == "Images") {
            if (element.type.startsWith("image/")) {
              setEquipmentImagesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
              }));
            }
          } else {
            fileName = element.name;
            fileExtension = fileName.split(".").pop().toLowerCase();
            if (fileExtension != "exe" && fileExtension != "bat") {
              setEquipmentFilesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
              }));
            }
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(element);
      });

      event.dataTransfer.clearData();
      if (type == "Images") {
        setEquipmentImagesData((prevState) => ({
          ...prevState,
          dropDepth: 0,
          inDropZone: false,
        }));
      } else {
        setEquipmentFilesData((prevState) => ({
          ...prevState,
          dropDepth: 0,
          inDropZone: false,
        }));
      }
    }
  };

  const handleDragOver = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        inDropZone: true,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        inDropZone: true,
      }));
    }
  };

  const handleDragEnter = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth + 1,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth + 1,
      }));
    }
  };

  const handleDragLeave = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth - 1,
      }));
      if (equipmentImagesData.dropDepth > 0) return;
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        inDropZone: false,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth - 1,
      }));
      if (equipmentFilesData.dropDepth > 0) return;
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        inDropZone: false,
      }));
    }
  };

  const equipmentFilesHandleOnchange = (event, type) => {
    var files = [...event.target.files];
    var fileName = "";
    var fileExtension = "";
    if (files && files.length > 0) {
      files.map((file) => {
        if (type === "Images" && !file.type.startsWith("image/")) {
          toast.error(localization.onlyImagesAllowed);
          return false;
        }

        if (type === "Files") {
          fileName = file.name;
          fileExtension = fileName.split(".").pop().toLowerCase();
          if (fileExtension === "exe" || fileExtension === "bat") {
            toast.error(localization.executableFilesNotAllowed);
            return false;
          }
        }
      });
      const existingFiles =
        type == "Images"
          ? equipmentImagesData.fileList.map((f) => f.name)
          : equipmentFilesData.fileList.map((f) => f.name);
      files = files.filter((f) => !existingFiles.includes(f.name));
      files.forEach((element) => {
        let reader = new FileReader();
        reader.onload = () => {
          if (type == "Images") {
            if (element.type.startsWith("image/")) {
              setEquipmentImagesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
                dropDepth: 0,
                inDropZone: false,
              }));
            }

            if (ImageFileInputRef.current) {
              ImageFileInputRef.current.value = ""; // Clear the input value
            }
          } else {
            fileName = element.name;
            fileExtension = fileName.split(".").pop().toLowerCase();
            if (fileExtension != "exe" && fileExtension != "bat") {
              setEquipmentFilesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
                dropDepth: 0,
                inDropZone: false,
              }));
            }

            if (FileInputRef.current) {
              FileInputRef.current.value = ""; // Clear the input value
            }
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(element);
      });
    }
  };

  const removeFiles = (type, fileName) => {
    if (type == "Images") {
      let tempFiles = { ...equipmentImagesData };
      let files = tempFiles.fileList.filter((f) => f.name != fileName);
      let filesToStrArray = tempFiles.filetoStringarray.filter(
        (f) => f.Filename != fileName,
      );
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        fileList: files,
        filetoStringarray: filesToStrArray,
      }));
    } else {
      let tempFiles = { ...equipmentFilesData };
      let files = tempFiles.fileList.filter((f) => f.name != fileName);
      let filesToStrArray = tempFiles.filetoStringarray.filter(
        (f) => f.Filename != fileName,
      );
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        fileList: files,
        filetoStringarray: filesToStrArray,
      }));
    }
  };

  return renderMe === null ? (
    <></>
  ) : (
    <>
      <div
        className="modal in dialogBox"
        id="editEquipmentDetailsModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editEquipmentDetailsModal"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="custom-modal modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="editEquipmentDetailsModalTite">
                {localization.editEquipment}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="editEquipmentDetailsModalClose"
                onClick={() => {
                  setIsEdit(false);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="table-responsive panel-body panel-height tabscroll">
                <fieldset disabled={disabled}>
                  <form onSubmit={handleSubmit} className="form-signin">
                    <div className="container-fluid">
                      <div className="row editEquipForm">
                        {renderMe}
                        <div className="fileUploadContainer">
                          <div className="equipmentPictureContainer">
                            <h3>{localization.pictureOfEquipment}</h3>
                            {equipmentImagesData.filetoStringarray &&
                            equipmentImagesData.filetoStringarray.length > 0 ? (
                              <>
                                <ImageList cols={4} gap={10}>
                                  {equipmentImagesData.filetoStringarray.map(
                                    (f, index) => {
                                      return (
                                        <ImageListItem key={`img-` + index}>
                                          <img
                                            src={f.Filecontent}
                                            alt={""}
                                            loading="lazy"
                                            className="thumbnail"
                                          />
                                          <span
                                            className="deleteImgCls"
                                            onClick={() => {
                                              removeFiles("Images", f.Filename);
                                            }}
                                          >
                                            <RemoveCircleOutlinedIcon fontSize="large" />
                                          </span>
                                        </ImageListItem>
                                      );
                                    },
                                  )}
                                </ImageList>
                              </>
                            ) : (
                              <></>
                            )}

                            <div className="pictureContainer">
                              <div
                                className=""
                                onDrop={(e) => handleDrop(e, "Images")}
                                onDragOver={(e) => handleDragOver(e, "Images")}
                                onDragEnter={(e) =>
                                  handleDragEnter(e, "Images")
                                }
                                onDragLeave={(e) =>
                                  handleDragLeave(e, "Images")
                                }
                              >
                                <input
                                  type="file"
                                  ref={ImageFileInputRef}
                                  className="fileUploadInput"
                                  accept="image/*"
                                  onChange={(e) => {
                                    equipmentFilesHandleOnchange(e, "Images");
                                  }}
                                  multiple
                                />
                                <div>{localization.dragAndDropMessage}</div>
                                <div className="">
                                  <img src="bootstrap_dist_new/bootstrap_dist/img/FileUploadPlusIcon.svg"></img>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="equipmentFileContainer">
                            <h3>{localization.equipFileStore}</h3>
                            {equipmentFilesData.fileList &&
                            equipmentFilesData.fileList.length > 0 ? (
                              <>
                                <ul className="fileList">
                                  {equipmentFilesData.fileList.map(
                                    (f, index) => {
                                      return (
                                        <li key={index}>
                                          {f.name}{" "}
                                          <span
                                            className="float-right"
                                            onClick={() => {
                                              removeFiles("Files", f.name);
                                            }}
                                          >
                                            <RemoveCircleOutlinedIcon fontSize="large" />
                                          </span>
                                        </li>
                                      );
                                    },
                                  )}
                                </ul>
                              </>
                            ) : (
                              <></>
                            )}

                            <div className="pictureContainer">
                              <div
                                className=""
                                onDrop={(e) => handleDrop(e, "Files")}
                                onDragOver={(e) => handleDragOver(e, "Files")}
                                onDragEnter={(e) => handleDragEnter(e, "Files")}
                                onDragLeave={(e) => handleDragLeave(e, "Files")}
                              >
                                <input
                                  type="file"
                                  ref={FileInputRef}
                                  className="fileUploadInput"
                                  onChange={(e) => {
                                    equipmentFilesHandleOnchange(e, "Files");
                                  }}
                                  multiple
                                />
                                <div>{localization.dragAndDropMessage}</div>
                                <div className="">
                                  <img src="bootstrap_dist_new/bootstrap_dist/img/FileUploadPlusIcon.svg"></img>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {!commonUtils.isReader() && (
                        <div className="text-center mt-5">
                          <button
                            type="submit"
                            className="btn btn-primary saveBtnCls"
                          >
                            {localization.saveEquipment}
                          </button>
                        </div>
                      )}
                    </div>
                  </form>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
        isCancelShow={false}
      />
    </>
  );
};
export default Allgemein;
